// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkNative_link__hGO0Z"};